import React, { useRef, useEffect } from 'react';
import { Message } from '../types';

interface ChatWindowProps {
  messages: Message[];
  failedAction: string | null;
  isGameOver: boolean;
  isThinking: boolean;
  onRetry: (action: string) => void;
}

const ChatWindow: React.FC<ChatWindowProps> = ({
  messages,
  failedAction,
  isGameOver,
  isThinking,
  onRetry
}) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);

  // Add auto-scroll effect
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div 
      ref={chatContainerRef}
      className="chat-container"
    >
      {messages && messages.map((message, index) => (
        <div 
          key={index} 
          className={`message ${message.type} ${message.isThinking ? 'thinking' : ''} ${message.isFeedback ? 'feedback' : ''} ${message.error ? 'error' : ''}`}
          data-testid={`message-${index}`}
        >
          {message.isThinking ? (
            <div className="thinking-indicator">
              <span>•</span>
              <span>•</span>
              <span>•</span>
            </div>
          ) : (
            <>
              {message.content}
              {message.error && failedAction && !isGameOver && (
                <button 
                  className="retry-btn"
                  onClick={() => onRetry(failedAction)}
                  disabled={isThinking}
                >
                  Retry
                </button>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default ChatWindow; 